import { useTranslation } from "react-i18next";
import { SERVICES } from "../data/content";

export default function ServicesPage() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-7xl px-4 py-16">
      <h1 className="text-4xl font-bold">{t("services.heading")}</h1>
      <p className="mt-2 text-slate-600">{t("services.subheading")}</p>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((_, i) => (
          <div
            key={i}
            className="rounded-2xl border border-slate-200 p-6 transition-transform duration-300 hover:scale-[1.01] hover:shadow-md"
          >
            <h3 className="font-semibold">{t(`services.items.${i}.title`)}</h3>
            <p className="mt-2 text-sm text-slate-600">
              {t(`services.items.${i}.desc`)}
            </p>
          </div>
        ))}
      </div>

      {/* NEW: lifecycle note */}
      <p className="mt-6 text-sm text-slate-500">
        {t("services.note")}
      </p>
    </section>
  );
}
